export default __webpack_public_path__ + "static/media/icon-eye-hide.2dc9d8fb.svg";